//As default Webpack will not make function globally available, to not litter the global scope.
//If you want the function to be accessible outside the scope of the JS file, you should put it in the global scope.

//'fieldIds' is excepted to be an array of id to input fields.
function disableAutocompleteOnFields(fieldIds) {

    let isBrowserChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
    for (var fieldId of fieldIds) {
        let elementId = `${fieldId}`;
        if (isBrowserChrome) {
            document.getElementById(elementId).setAttribute("autocomplete", "whatever-google-do-not-like-off");
        } else {
            document.getElementById(elementId).setAttribute("autocomplete", "off");
        }
    }

}
window.disableAutocompleteOnFields = disableAutocompleteOnFields;